// eslint-disable-next-line consistent-return
function findPath(obj, item) {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (obj[key] && typeof obj[key] === 'object') {
      const result = findPath(obj[key], item);
      if (result) {
        result.unshift(key);
        return result;
      }
    } else if (obj[key] === item) {
      return [key];
    }
  }
}

export default findPath;
